import { render, staticRenderFns } from "./appro.vue?vue&type=template&id=b38f78e4"
import script from "./appro.vue?vue&type=script&lang=tsx"
export * from "./appro.vue?vue&type=script&lang=tsx"
import style0 from "./appro.vue?vue&type=style&index=0&id=b38f78e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports